import * as types from './types';
import { has } from 'lodash';

const INITIAL_STATE = {
  fetching: false,
  fetchError: null,
  gridData: null,
  saveSuccessful: false,
  newCycleMenu: {
    id: null,
    description: null,
    numberOfDays: null,
    nutritionStandardId: null,
    fiscalYear: null,
    servings: null,
    analysisDays: null,
  },
  editing: false,
  editCycleValues: {
    id: null,
    description: null,
    numberOfDays: null,
    nutritionStandardId: null,
    fiscalYear: null,
    servings: null,
    analysisDays: null,
  },
  duplicating: false,
  duplicateFetching: false,
  shareSuccessful: false,
  unshareSuccessful: false,
  sharedDistricts: [],
  fetchSharedDistrictsError: null,
  shareError: null,
  unshareError: null,
  isParentDistrict: false,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.MANAGE_CYCLE_MENU_SET_GRID_DATA:
      return {
        ...state,
        gridData: payload,
      };

    case types.MANAGE_CYCLE_MENU_SET_SAVE_SUCCESSFUL:
      return {
        ...state,
        saveSuccessful: payload,
      };

    case types.MANAGE_CYCLE_MENU_SET_NEW_CYCLE_MENU:
      return {
        ...state,
        newCycleMenu: payload,
      };

    case types.MANAGE_CYCLE_MENU_FETCHING:
      return {
        ...state,
        fetching: payload,
      };

    case types.MANAGE_CYCLE_MENU_FETCH_ERROR:
      if (has(payload, 'response.data.Errors')) {
        const fetchError = payload.response.data.Errors[0];

        return {
          ...state,
          fetchError,
        };
      }

      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message:
            'An error occurred while retrieving menus data. Please try again',
        },
      };

    case types.MANAGE_CYCLE_MENU_CLEAR_ERRORS:
      return {
        ...state,
        fetchError: null,
        fetchSharedDistrictsError: null,
        shareError: null,
      };

    case types.MANAGE_CYCLE_MENU_SET_EDITING:
      return { ...state, editing: payload };

    case types.MANAGE_CYCLE_MENU_SET_EDIT_CYCLE_VALUES:
      return { ...state, editCycleValues: { ...payload } };

    case types.MANAGE_CYCLE_MENU_SET_DUPLICATING:
      return { ...state, duplicating: payload };

    case types.MANAGE_CYCLE_MENU_DUPLICATE_FETCHING:
      return { ...state, duplicateFetching: payload };

    case types.MANAGE_CYCLE_MENU_SET_SHARE_SUCCESS:
      return { ...state, shareSuccessful: payload };

    case types.MANAGE_CYCLE_MENU_GET_SHARED_DISTRICTS:
      return { ...state, sharedDistricts: payload };

    case types.MANAGE_CYCLE_MENU_SHARE_ERROR:
      return { ...state, shareError: payload };

    case types.MANAGE_CYCLE_MENU_GET_SHARED_DISTRICTS_ERROR:
      return { ...state, fetchSharedDistrictsError: payload };

    case types.MANAGE_CYCLE_MENU_SET_UNSHARE_SUCCESS:
      return { ...state, unshareSuccessful: payload };

    case types.MANAGE_CYCLE_MENU_UNSHARE_ERROR:
      return { ...state, unshareError: payload };

    case types.MANAGE_CYCLE_MENU_GET_IS_PARENT_DISTRICT:
      return { ...state, isParentDistrict: payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/listcycles/reducer.js